<template>
  <label class="input"
         :class="selector">
    <div v-if="label"
         class="input__label">
      <span>{{ label }}
        <span v-if="isAttributeTrue($attrs.required)"
              class="input__required"> *</span>
      </span>
    </div>

    <slot :focusHandler="focusHandler" :blurHandler="blurHandler">
      <div class="input__wrapper">
      <textarea v-if="textarea"
                v-bind="$attrs"
                @change="onChange"
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur"
                :value="value"
                :style="style"
                ref="input"
                class="input__input"/>

        <input v-else-if="$attrs.type === 'file'"
               v-bind="$attrs"
               @change="onChange"
               @input="onInput"
               @focus="onFocus"
               @blur="onBlur"
               :value="value"
               :style="style"
               ref="input"
               :type="$attrs.type"
               class="input__input">

        <input v-else-if="mask"
               v-bind="$attrs"
               @change="onChange"
               @input="onInput"
               @focus="onFocus"
               @blur="onBlur"
               :value="value"
               v-mask="maskOptions"
               :style="style"
               ref="input"
               :type="$attrs && $attrs.type ? $attrs.type : 'text'"
               class="input__input">

        <input v-else
               v-bind="$attrs"
               @change="onChange"
               @input="onInput"
               @focus="onFocus"
               @blur="onBlur"
               :value="value"
               :style="style"
               ref="input"
               :type="($attrs && $attrs.type && !isVisiblePassword) ? $attrs.type : 'text'"
               class="input__input">

        <div v-if="isPassword" class="test_svg" @click.stop="showPassword()">
          <svg xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="#ico-eye"></use>
          </svg>
        </div>
      </div>


    </slot>

    <InputError :value="error"/>
  </label>
</template>

<script>
import InputError from './BaseInputError'

export default {
  inheritAttrs: false,
  components: {
    InputError
  },
  props: {
    value: null,
    label: null,
    textarea: {
      type: Boolean,
      default: false
    },
    overTitle: {
      type: Boolean,
      default: true
    },
    leftSpace: Number,
    error: {
      type: [String, Array]
    },
    mask: null
  },
  data() {
    return {
      focus: false,
      isVisiblePassword: false
    }
  },
  computed: {
    isPassword() {
      return this.$attrs.type === 'password'
    },
    filled() {
      return !!this.value || Number.isFinite(this.value)
    },
    selector() {
      let selector = ''
      if (this.overTitle) selector += ' _over '
      if (this.focus) selector += ' _focus '
      if (this.filled) selector += ' _filled '
      if (this.error) selector += ' _error '
      if (this.isPassword) selector += ' _password '
      return selector
    },
    style() {
      let s = {}

      if (this.leftSpace) {
        s.paddingLeft = (17 + this.leftSpace) + 'px'
      }

      return s
    },
    maskOptions() {
      return {
        mask: this.mask,
        autoUnmask: true,
        showMaskOnHover: false
      }
    }
  },
  methods: {
    showPassword() {
      this.isVisiblePassword = !this.isVisiblePassword
      // this.$attrs.type === 'text' ? this.$attrs.type = 'password' : this.$attrs.type = 'text'
    },
    focusHandler() {
      this.onFocus()
    },
    blurHandler() {
      this.onBlur()
    },
    onChange(event) {
      this.$emit('change', event.target.value)
    },
    onFocus() {
      this.focus = true
      this.$emit('focus')
    },
    onBlur() {
      this.focus = false
    },
    onInput(event) {
      if (this.$attrs.type === 'file') {
        this.$emit('input', event)
      } else {
        this.$emit('input', this.formatValue(event.target.value))
      }
    },
    isAttributeTrue(attr) {
      return attr || attr === ''
    },
    formatValue(value) {
      if (this.$attrs.type === 'number') {
        value = value.replace(',', '.')
        value = parseFloat(value)
      }

      return value
    }
  }
}
</script>

<style lang="less">
.test_svg {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  width: 40px;
  height: 44.8px;

  & svg {
    width: 20px;
    height: 20px;

    fill: black;
  }
}
</style>
